/* After migration to typescript@4.1 replace to `#${string}` */
export type HexColor = string;
